import React, { useEffect, type FC } from 'react'

import { useRecoilCallback } from 'recoil'

import { Flex, ToastContainer, Tooltip } from 'mailup-web-components'

import Page from 'Containers/Page'

import Header from 'Pages/GroupsOverlap/components/Header'
import Intro from 'Pages/GroupsOverlap/components/Intro'
import Results from 'Pages/GroupsOverlap/components/Results'
import Search from 'Pages/GroupsOverlap/components/Search'
import {
  initPageCallback,
  resetPageCallback,
} from 'Pages/GroupsOverlap/recoil/callbacks/callbacks'

const GroupsOverlap: FC = () => {
  const initPage = useRecoilCallback(initPageCallback, [])
  const resetPage = useRecoilCallback(resetPageCallback, [])

  useEffect(() => {
    void initPage()

    return () => {
      void resetPage()
    }
  }, [initPage, resetPage])

  return (
    <>
      <Header />
      <Tooltip />
      <ToastContainer />

      <Page onReload={initPage}>
        <Flex flexDirection="column" gap="24px">
          <Intro />
          <Search />
          <Results />
        </Flex>
      </Page>
    </>
  )
}

export default GroupsOverlap
